import { withStyles } from "@material-ui/core";
import React from "react";
import baseStyles from "../../../../../../layout/layoutHeader/components/styles";
import { DISPATCH_MAP_FILTERS } from "../../constants";
import CustomMultiSelect from "../../CustomMultiSelect";
import { getSelectedMapFilters } from "../../filterUtils";

const styles = (theme) => ({
  ...baseStyles(theme),
  multiSelectWrapper: {
    width: 150
  },
  inputField: {
    padding: "6px 8px"
  }
});

class MapStopFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
    };
  }

  componentDidMount() {
    this.updateSelectedOptions(this.getFilteredOption())
  }

  updateSelectedOptions = (options) => {
    const selectedOptions = [...options];
    this.setState({
      selectedOptions,
    }, () => {
      this.props.stack.layoutManager.eventHub.emit(
        `${this.props.headerId}_multiSelectSelected`,
        selectedOptions
      );
    });
  };

  getFilteredOption = () => {
    const filters = getSelectedMapFilters(this.props.stopsFilter);
    return this.DISPATCH_MAP_FILTER_LIST.filter((option) =>
      filters.includes(option.value)
    );
  };

  getDispatchMapFilters = () => {
    return [
      {
        label: "Pickups - Completed",
        value: DISPATCH_MAP_FILTERS.pickupCompleted,
      },
      { label: "Pickups - Pending", value: DISPATCH_MAP_FILTERS.pickupPending },
      {
        label: `Pickups - ${this.props.priorityShipmentList.toString()}`,
        value: DISPATCH_MAP_FILTERS.pickupPriority,
      },
      {
        label: "Deliveries - Completed",
        value: DISPATCH_MAP_FILTERS.deliveryCompleted,
      },
      {
        label: "Deliveries - Pending",
        value: DISPATCH_MAP_FILTERS.deliveryPending,
      },
      {
        label: "Deliveries - Returned",
        value: DISPATCH_MAP_FILTERS.deliveryReturned,
      },
      {
        label: `Deliveries - ${this.props.priorityShipmentList.toString()}`,
        value: DISPATCH_MAP_FILTERS.deliveryPriority,
      },
      {
        label: "Spotted Trailers",
        value: DISPATCH_MAP_FILTERS.spottedTrailers,
      },
    ];
  };

  render() {
    const { classes } = this.props;
    this.DISPATCH_MAP_FILTER_LIST = this.getDispatchMapFilters();
    return (
      <div className={`${classes.search} ${classes.iconLayout} glHeaderIcons`}>
        <CustomMultiSelect
          Options={this.DISPATCH_MAP_FILTER_LIST}
          handleChange={this.updateSelectedOptions}
          optionSelected={this.state.selectedOptions}
          persistentLabelText={'Stops on Map'}
          inputClasses={{ wrapper: classes.multiSelectWrapper, inputField: classes.inputField }}
        />
      </div>
    );
  }
}

export default withStyles(styles)(MapStopFilter);
